/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1BrandingMode } from '../models/V1BrandingMode';
import { V1ReportType } from '../models/V1ReportType';
import { HttpFile } from '../http/http';

/**
* PdfExportConfig holds settings that apply when export_type = PDF.
*/
export class V1PdfExportConfig {
    'brandingMode'?: V1BrandingMode;
    /**
    * ID of an asset of type ASSET_TYPE_BRAND_LOGO to use in the report header. Required when branding_mode = CUSTOM.
    */
    'brandLogoId'?: string;
    /**
    * When true, spend data is omitted from the report.
    */
    'excludeSpendData'?: boolean;
    /**
    * One or more sections to include.
    */
    'reportTypes': Array<V1ReportType>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "brandingMode",
            "baseName": "branding_mode",
            "type": "V1BrandingMode",
            "format": ""
        },
        {
            "name": "brandLogoId",
            "baseName": "brand_logo_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludeSpendData",
            "baseName": "exclude_spend_data",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reportTypes",
            "baseName": "report_types",
            "type": "Array<V1ReportType>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1PdfExportConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

